import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import _ from 'lodash'
import { Field, reduxForm } from 'redux-form';
import moment from 'moment'
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import axios from "axios";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import 'antd/dist/antd.css';
import { TimePicker } from 'antd';
import Util from '../../../Common/util';
import API from '../../../Common/api';
 
import "react-datepicker/dist/react-datepicker.css";
/*import './styles.css';
*/

var url = window.location.hostname;
var port = window.location.port;
const options2 = [
  { value: 'wmsUser', label: 'wmsUser' },
  { value: 'test', label: 'wmsUser' },
];

const optionsUser = [];



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.Errortoggle = this.Errortoggle.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

   
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
      loading: false,
      isLoading: false,
      reasonErr: false,
      showFetchGRNData: true,
      reasonData: [],
      alertMessage: '',
      messageModal: false,
      ErrorMessagemodal: false,
      modal: false,
      disabledBtnReason: true,
      batchData: [],
      Errormodal: false,
      Successmodal: false,
      reloadBtn: false,
      ErrorMessage: '',
      SuccessMessage: '',
    sorting: false,



    };
  }






  CancelSuccessToggle(){
    window.location.href = "/maintenance/cycleCountConfirmation";

  }

  

 
  Errortoggle() {
    this.setState(prevState => ({ Errormodal: !prevState.Errormodal }));
  }

  
  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }



  

 getReason = () =>{
    const payload = {
      location: this.state.selectedLocation,
      job_type : "CC"
    };

    API.post("/stock/fetchReasons/v1/", { param: payload })

      .then((response) => response.data)

      .then((data) => {

        //console.log(data, "reason")
      
        this.setState({ reasonData: data});
      })

      .then(async () => {});
  }

  



  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }
        else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location
      })

      localStorage.setItem('userName' , username);
    }



   createCookie(cookieName,cookieValue,daysToExpire)
        {
          var date = new Date();
          date.setTime(date.getTime()+(1*24*60*60*1000));
          document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
        }

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }




  componentDidMount() {
    this.fetchGRNData();
    this.getReason();
      
      
  }

  fetchGRNData(){

      /*var UserId = localStorage.getItem('userId');*/
      var Batch = localStorage.getItem('batch')
      this.setState({
        
        loading: true,
        postsGRN: [],
        tableRowsGRN: [],
        tableRowsGRNTester: [],
        

      })
      const payload = {
        batch: Batch , location: this.state.selectedLocation,
      };
      
    API.post('/cycle_count/fetchCycleRecon/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {
         
         console.log("CYCLE COUNT DATA - ",data);
         // if (err) throw err;


         this.setState({ batchData: data})

         let filtered_data = data.bin_data.filter(item => item.reason_needed == true)

          let newBinData =
        filtered_data.map(item => ({...item, capture_reason: "" })
           
          
        )



        this.setState({
          batchData: newBinData,
          productData: data.product_data
        })

       





        console.log("BATCH DATA -",this.state.batchData);
         



      })

      .then(async() => {

        if (this.state.showFetchGRNData) {

         this.setState({  loading: false })

        } else{

          this.setState({ loading: false })

        }

         console.log(this.state.tableRowsGRN);

      });
  }

  
      



  


  reasonCaptured = ()=>{

    
    this.setState({
      isLoading: true
    })
    var checkValidReason = this.state.batchData.filter(item=> item.capture_reason == "")

    if(checkValidReason.length > 0 ){
      this.setState({
        reasonErr: true,
        isLoading: false
      })
      return false;
    }else{
      this.setState({
        reasonErr: false,
        
      })
      var arr = [];
      
      for( var i = 0; i< this.state.batchData.length ; i++){
        var obj = {};

        obj['reconcile_ids'] = [this.state.batchData[i].id];
        obj['reason_id'] = this.state.batchData[i].capture_reason

        arr.push(obj)
      }

     var payload = {
        arr
      }

      console.log("REASONDATA", arr);
       API.post('/cycle_count/updateReason', { param: arr })
      
          .then((response) =>  {


            if(response.data.success == true){
              this.setState({
                success_message: response.data.message,
                isLoading: false
              })
              this.Successtoggle();
            }else{
              this.setState({
                ErrorMessage: response.data.message,
                isLoading: false
              })
              this.Errortoggle();
            }
            
            
          })
          .catch(function (error) {
            
            
        })
    


    }



  }




  


  
  changeReason = (evt, index, id) => {
    const { batchData } = this.state;
    
    var reason = evt.target.value;
    batchData[index]["capture_reason"] = reason;
    
    
    console.log("BATCHData",batchData);
    

   


    this.setState({
      loadingbtn: !this.state.loadingbtn,
      batchData: batchData,
      showFetchGRNData: true
      //tableRowsMap: this.assembleDispatchData(arr_data),
    },() => console.log("this.state.batchData", this.state.batchData));
  }


  sortingColumn = (col_name) => {
  console.log(col_name);
  if(this.state.sorting == false){
    var items = this.state.batchData.sort(function (a, b) {
      var textA = a[col_name];
      var textB = b[col_name];
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }); 
  }else{
    var items = this.state.batchData.sort(function (a, b) {
      var textA = a[col_name];
      var textB = b[col_name];
      return textA > textB ? -1 : textA < textB ? 1 : 0;
    });
  }
  
  this.setState({
    batchData : items,
    sorting: !this.state.sorting,
  })
  console.log(this.state.batchData);
  }


  render() {
    const { handleSubmit, reset, t } = this.props;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal, modalAssignUserCycleCount, StepSuccessModal } = this.state;
    const {Confirmmodal} = this.state;
    const {modalbeforeConfirm} = this.state;
    const {EditModal} = this.state;
    const {ErrorMessagemodal} = this.state;



    return (
      <Col xl={12}>
        <Card>
    

          {this.state.showFetchGRNData &&

           <div>
            <div>

             <div style={{width: '100%',}}>
             

               <ButtonToolbar style={{height: 8, width: '14%', float: 'left'}}  className="form__button-toolbar">
                          
                          <Button  style={{backgroundColor: '#fdd666',  margin: 0 , paddingTop: 4, paddingBottom: 4 , paddingLeft: 10, paddingRight: 10, fontWeight: 'bold', fontSize: 12, }} className="modal_ok"   onClick={this.reasonCaptured}>
                          {this.state.isLoading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }  
                          Submit</Button> 
                          

                          {this.state.reasonErr &&
                          <span
                                 
                                  style={{ fontSize: 12, color: "red" }}
                                >
                                  {" "}
                                  Please Select Reason
                                </span>
                              }              
                          
              </ButtonToolbar>


              </div>

            </div>
            
            <div className="table_val1" style={{marginTop: '5%'}}>
               <Table responsive className="table--bordered change_color">
                    <thead>
                      <tr>

                           
                        <th onClick={() => this.sortingColumn("bin_address")}>Bin Address</th>
                        <th onClick={() => this.sortingColumn("match_status")}>Status(physical scan)</th>
                        <th onClick={() => this.sortingColumn("lb_sku_id")}>Prod Code</th>
                        <th onClick={() => this.sortingColumn("product_desc")}>Product Desc</th>
                        <th>MRP </th>
                        <th>UPC</th>
                        <th>ICLD Quantity</th>
                        <th>Loose Quantity</th>
                        <th>Total Scanned Qty</th>
                        <th>System Quantity</th>
                        <th>Deviation by value (in %)</th>
                        <th> Deviation by Qty (in %) </th>
                        <th>Bin Suggested(scanned product)</th>
                        <th onClick={() => this.sortingColumn("icld_ean")}>ICLD EAN</th>
                        <th onClick={() => this.sortingColumn("ean")}>EAN</th>
                        <th>Action</th>
          {/* <th onClick={() => this.sortingColumn("user")}>Assigned User</th>
                        
                        
                        
                        
                        <th onClick={() => this.sortingColumn("zone_name")}>Zone Name</th>
                        <th>Zone Id</th>

                        <th>PKD </th>
            <th>BasePack Code</th>
                        <th>CBU Code</th>*/}

                        
                        
                        
                      
                       
                      </tr>
                    </thead>
                    <tbody>

                      {this.state.batchData.length > 0 && (

                        this.state.batchData.map((item, index) => (

                          <tr style={{ backgroundColor: item.color,  textAlign: 'left' }}>
                            

                            
                
                            <td style= {{color: '#232329'}}> {item.bin_address} </td>
                           
                            {item.match_status === "MATCH" ? 
                            (
                              <td style={{color: "green", fontWeight: 'bold'}}> {item.match_status} </td>
                            ):(
                              <td style={{color: "#ca0707", fontWeight: 'bold'}}> {item.match_status} </td>
                            )}
                            <td style= {{color: '#232329'}}> {item.product_code} </td>
                            <td style= {{color: '#232329'}}> {item.product_desc} </td>
                             <td style= {{color: '#232329'}}> {item.mrp} </td>
                             <td style= {{color: '#232329'}}> {item.upc} </td>
                             <td style= {{color: '#232329'}}> {item.icld_qty} </td>
                            <td style= {{color: '#232329'}}> {item.loose_qty} </td>
                             <td style= {{color: '#232329'}}> {item.scanned_qty} </td>
                            <td style= {{color: '#232329'}}> {item.system_qty} </td>
                             <td style= {{color: '#232329'}}> {item.value_deviation} </td>
                            <td style= {{color: '#232329'}}> {item.qty_deviation} </td>
                           
                            <td style={{color: '#70bbfd' , fontWeight: 'bold'}}> {item.suggested_bin} </td>


                             {(item.match_status === "JUNK" || item.match_status === "PRODUCT MISMATCH" || item.match_status === "PRODUCT NOT FOUND" || item.match_status === "EMPTY BIN" && item.ean == "" ) ? 
                          (
                            <td style= {{color: '#232329'}}> {item.icld_ean} </td>
          
                          ):(
                            <td> </td>
                          )

                          }

                          {(item.match_status === "JUNK" || item.match_status === "PRODUCT MISMATCH" || item.match_status === "PRODUCT NOT FOUND" || item.match_status === "EMPTY BIN" && item.icld_ean == "" ) ? 
                          (
                            <td style= {{color: '#232329'}}> {item.ean} </td>
          
                          ):(
                            <td> </td>
                          )

                          }

                         
                           
                            
                           {/* <td style= {{color: '#232329'}}> {item.zone_name} </td>
                            <td style= {{color: '#232329'}}> {item.zone_id} </td>

                           
                            <td style= {{color: '#232329'}}> {item.pkd} </td>
              <td style= {{color: '#232329'}}> {item.base_pack_code} </td>
                            <td style= {{color: '#232329'}}> {item.cbu_code} </td>*/}

                          <td>
                           <select
                              className="form-control"
                              style={{ fontSize: 13, width: 120 }}
                              onChange={(evt) => this.changeReason(evt, index)}
                            >
                              <option value="">Select Reason</option>
                              {this.state.reasonData.length > 0 &&
                                this.state.reasonData.map((reasonData) => {
                                  return (
                                    <option value={reasonData.id}> {reasonData.description}</option>
                                  );
                                })}

                            </select>

                            
                              {item.capture_reason == "" ? (
                                <span
                                 
                                  style={{ fontSize: 12, color: "red" }}
                                >
                                  {" "}
                                  Please Select Reason
                                </span>
                              ): (
                              <span
                                 
                                >
                                  
                                </span>
                              )}
                          </td>
                            
                            
                            
                           

                          </tr>



                        )))
                      }






                    </tbody>
                  </Table>
            </div>

         
          </div>
        }


       

        </Card>

        
                              
               



        

          <Modal
            isOpen={Errormodal}
            toggle={this.Errortoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Errortoggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.Errortoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

        <Modal
            isOpen={Successmodal}
            toggle={this.Successtoggle}
            >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
            

           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-checkmark-circle modal__title-icon" style={{color: 'green'}} />
            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.CancelSuccessToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>

       
      


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));
